export default __webpack_public_path__ + "static/media/tl-defi.f1ece191.png";